import { TableCell } from '@mui/material'
import UserChip from '../../../../../../chip/UserChip'
import ChipResult from './ChipResult'
import LcCard from './LcCard'

const ItemStudent = ({ student, lcs, result }) => {
  return (
    <>
      <TableCell>
        <UserChip
          name={student?.fullName}
          {...student}
          variant='outlined'
          className='border-none'
          maxWidth='250px'
        />
      </TableCell>
      <TableCell className='flex gap-2 items-center justify-end'>
        <div className='flex gap-2 items-center justify-end'>
          {lcs?.map((lc) => (
            <LcCard
              key={`student-${student?.studentId}-lc-${lc.lcId}`}
              lc={lc}
              color={lc?.level?.color || 'grey'}
            />
          ))}
        </div>
        <ChipResult
          result={result?.name || 'Unknown'}
          color={result?.color || 'default'}
          bgColor={result?.bgColor || 'default'}
          border={result?.border || false}
        />
      </TableCell>
    </>
  )
}

export default ItemStudent
